export default __webpack_public_path__ + "static/media/gallery-wip-pommel_10.90a052d7.jpg";